import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BasePage from 'pages/base'
import CommonLayout from 'components/layout/common'
import ProductsApiHandler from 'lib/api/products'
import PurposeHeroAndDesc from 'components/purpose/hero-and-desc'
import PurposeImageGroup from 'components/purpose/image-group'
import PurposeJoinAndDonate from 'components/purpose/join-and-donate'
import PurposeShopCollection from 'components/purpose/shop-collection'
import StateStorage from 'lib/state-storage'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { withI18next } from 'lib/i18n/withI18next'
import { getShopInfo } from 'lib/utils/shop-lang'
import { PAGE_NAME } from 'pages/const'
import styles from './styles.scss'
import { PURPOSE_METADATA, PURPOSE_SHARED } from './const'

class Purpose extends BasePage {
  static getInitialProps({ store, req, res, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }

    return {}
  }

  state = {
    products: null,
  }

  afterPageMount() {
    this.getPurposeProducts()
  }

  async getPurposeProducts(categoryId = PURPOSE_SHARED.categoryId, limit = 4) {
    const options = {
      categoryId,
      shop: StateStorage.getShop(),
      skip: 0,
      limit,
    }
    const res = await ProductsApiHandler.getList(options)
    this.setState({ products: res.products })
  }

  getPageMeta() {
    const { t } = this.props

    return {
      title: hasLocizeTranslation(
        t,
        PURPOSE_METADATA.titleKey,
        PURPOSE_METADATA.title,
      ),
      description: hasLocizeTranslation(
        t,
        PURPOSE_METADATA.descriptionKey,
        PURPOSE_METADATA.description,
      ),
    }
  }

  goToNextSection = () => {
    const nextSectionEl = document.getElementById('purpose_after_hero')
    const { isPhone } = this.props
    let OFFSET = 150

    // Tweaks the offset according to platform and the header.
    if (isPhone) {
      const headerSmallEl = document.querySelector(
        'header.top-nav.header.fixed',
      )

      OFFSET += headerSmallEl ? -70 : -20
    } else {
      const headerBigEl = document.querySelector('header.top-nav.header.large')

      if (headerBigEl) {
        OFFSET += 100
      }
    }

    const bodyTop = document.body.getBoundingClientRect().top
    const elTop = nextSectionEl.getBoundingClientRect().top
    const finalPos = elTop - bodyTop - OFFSET

    window.scroll({ top: finalPos, behavior: 'smooth' })
  }

  render() {
    const { internationalization: i18n, isPhone, t } = this.props
    const { products } = this.state
    const currentShop = getShopInfo({ key: 'id_shop', value: i18n.shop })

    return (
      <CommonLayout
        meta={this.getPageMeta()}
        noSidePadding={!isPhone}
        pageName={PAGE_NAME.purpose}
      >
        <style jsx>{styles}</style>
        <section className="purpose-base__top-wrapper">
          <PurposeHeroAndDesc
            isPhone={isPhone}
            onClick={this.goToNextSection}
            t={t}
          />
          <PurposeImageGroup isPhone={isPhone} t={t} />
        </section>
        {currentShop.offline_available && (
          <PurposeJoinAndDonate isPhone={isPhone} t={t} />
        )}
        <PurposeShopCollection isPhone={isPhone} products={products} t={t} />
      </CommonLayout>
    )
  }
}

Purpose.propTypes = {
  internationalization: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
  isPhone: PropTypes.bool.isRequired,
}

const Extended = withI18next(['global'])(Purpose)

export { Purpose }

export default connect(
  /* istanbul ignore next */
  (state) => ({
    internationalization: state.internationalization,
    isPhone: state.device.isPhone,
  }),
)(Extended)
